module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "full-header"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "intro-text"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('p', [_vm._v("Based in Southbury, CT, we’ve been providing\n                  "), _c('i', [_vm._v("digital design and development services")]), _vm._v("\n                   to agencies and brands like MTV,\n                   ESPN, Konami, and Turner Broadcasting for over " + _vm._s(_vm.yearsInBusiness) + " years. That’s " + _vm._s(_vm.yearsInBusiness) + " years worth of knowledge,\n                   experience, and understanding which we bring to each and every\n                   project that we take on. We’ve got thousands of apps, games, promotions, and banner campaigns under our belt - if you’ve seen\n                   the Internet, you’ve probably seen our work!\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  Over the years we’ve assembled an amazing in-house staff plus a roster of incredibly talented, local designers and developers.\n                  That means we have the unique ability to flex our staff at a moment’s notice. Even last minute projects are no problem for us!\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  For agency clients, we’re happy to provide white-labeled services to compliment your in-house capabilities.  Whether it’s handling\n                  a small portion of a larger project or providing an entire digital solution, we’re here to help.\n                ")])])])])])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Our goal is simple: Exceed our clients' expectations\n                  and make them look like "), _c('br', {
    staticClass: "visible-lg"
  }), _vm._v(" rock stars.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-10 col-xs-offset-1"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("assets/images/about_gadgets.svg"),
      "alt": "Gadgest Image."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-xs-offset-1"
  }, [_c('h1', [_vm._v("Depending on your needs, we can provide any or all of these services for your projects:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-xs-offset-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 service"
  }, [_c('img', {
    staticClass: "svg scale110",
    attrs: {
      "src": require("assets/images/about_brainstorm.svg"),
      "alt": "Brainstorming"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Concept brainstorming")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 service"
  }, [_c('img', {
    staticClass: "svg scale110",
    attrs: {
      "src": require("assets/images/about_requirements.svg"),
      "alt": "Brainstorming"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Requirements /")]), _vm._v(" "), _c('h5', [_vm._v("specifications documentation")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 service"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "src": require("assets/images/about_info.svg"),
      "alt": "Brainstorming"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Information Architecture "), _c('br'), _vm._v(" (Sitemaps and Wireframes)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 service"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "src": require("assets/images/about_ui.svg"),
      "alt": "Brainstorming"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("User experience expertise")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 service"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "src": require("assets/images/about_design.svg"),
      "alt": "Brainstorming"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Design")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 service"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "src": require("assets/images/about_dev.svg"),
      "alt": "Brainstorming"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Development")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 service"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "src": require("assets/images/about_hosting.svg"),
      "alt": "Brainstorming"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Hosting")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 service"
  }, [_c('img', {
    staticClass: "svg",
    attrs: {
      "src": require("assets/images/about_maintenance.svg"),
      "alt": "Brainstorming"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Maintenance & Support")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ca51076!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 583
// module chunks = 2